
class Data {

    static server = "https://panel.shemshalmusic.ir/Shemshal/";
    static mainserver = "https://shemshalmusic.ir/Shemshal/";

}


export default Data;